// src/components/Admin/AdminNavbar.js
import { Box, Flex, Text, Avatar } from '@chakra-ui/react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';

const AdminNavbar = () => {
  const [user] = useAuthState(auth);

  return (
    <Box
     bg="customDark"
      borderBottom="1px solid"
      borderColor="gray.200"
      position="fixed"
      w="100%"
      zIndex="sticky"
      h="60px"
      px={6}
    >
      <Flex justify="space-between" align="center" h="100%">
        <Text fontSize="xl" fontWeight="bold">
          Admin Dashboard
        </Text>
        <Flex align="center">
          <Text mr={3}>{user?.email}</Text>
          <Avatar size="sm" name={user?.email} />
        </Flex>
      </Flex>
    </Box>
  );
};

export default AdminNavbar;